// extracted by mini-css-extract-plugin
module.exports = {"container":"Waves_container__aPqQu","waves":"Waves_waves__Klo7F","content":"Waves_content__NNI0I"};